import { Button, Card, Col, Drawer, Row, Space } from "antd";
import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import utils from "utils";
import { CheckCircleFilled } from "Common/ReactIcons";
import { CheckCircleOutlined } from "Common/ReactIcons";
import NestedFormViewer from "../NestedFormViewer";
import { RoundcheckGreen } from "Common/ReactIcons";
import { Roundcheck } from "Common/ReactIcons";
import { NewClose } from "Common/ReactIcons";
import { filterEmptyValues } from "./AIFormCombinedView";
function AIFormConflictDrawer(props) {
  const handleFormSelectToggle = (sltdFormItem, propName) => {
    const { id, label } = sltdFormItem;
    const updatedFormData = Object.fromEntries(
      Object.entries(props.conflictdata).map(([key, items]) => [
        key,
        items.map((item) =>
          item.id === id
            ? {
                ...item,
                is_accepted:
                  propName === "is_accepted" ? !item.is_accepted : false,
                is_rejected:
                  propName === "is_accepted" ? false : !item.is_rejected,
                is_reviewed: !item[propName],
                isSaved: false,
              }
            : label == item.label
            ? {
                ...item,
                is_rejected: false,
                is_accepted: false,
                is_reviewed: false,
                isSaved: true,
              }
            : item
        ),
      ])
    );
    props.setConflictdata(updatedFormData);
  };
  return (
    <Drawer
      title={"Conflicting Suggestions"}
      open={props.isConflict}
      width="35vw"
      closable={false}
      extra={
        <NewClose
          onClick={() => {
            props.setConflict();
          }}
        />
      }
    >
      <div className="AI-form-drawer-conflict">
        <div className="AutoFormContentContainer" id="message-container">
          <div
            className="fullCardsContent"
            // ref={containerRef}
          >
            {Object.entries(props.conflictdata).map(([key, value]) => (
              <Card
                // title={utils.capitalizeAndReplace(key.split("-")[1])}
                key={key}
              >
                <div className="title-div">
                  {utils.capitalizeAndReplace(key.split("-")[1])}
                </div>
                {filterEmptyValues(value).map((formItem, index) => {
                  return (
                    <div key={index}>
                      <div
                        // ref={endMessageFAQ}
                        id={`message-list-item-${index}`}
                        style={{
                          padding: "3px 12px",
                          // borderBottom: "1px solid #d0d5dd",
                          // borderRadius: "4px",
                          borderTop: "1px solid #d0d5dd",
                        }}
                      >
                        <Row align="middle">
                          <Col span={24} className="ques-rep-full-content">
                            <div className="questionAndAnswer">
                              <div>
                                <Row justify="space-between">
                                  <Col span={20}>
                                    <div>
                                      {!formItem.isObjectType && (
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "12px",
                                            // marginBottom: "20px",
                                          }}
                                        >
                                          <div className="label-aiForm">
                                            {utils.capitalizeAndReplace(
                                              formItem?.label
                                            )}
                                          </div>
                                          <div className="display-Value">
                                            {formItem.displayValue != null &&
                                            formItem.displayValue !== ""
                                              ? typeof formItem.displayValue ===
                                                "boolean"
                                                ? formItem.displayValue
                                                  ? "Yes"
                                                  : "No"
                                                : formItem.displayValue
                                              : formItem.value[
                                                  `is_${formItem?.label}`
                                                ] != null &&
                                                formItem.value[
                                                  `is_${formItem?.label}`
                                                ] !== ""
                                              ? formItem.value[
                                                  `is_${formItem?.label}`
                                                ]
                                                ? "Yes"
                                                : "No"
                                              : ""}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                  <Col
                                    span={4}
                                    className="ai-form-check-right-container"
                                  >
                                    <Space
                                      direction="horizontal"
                                      size="small"
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <div>
                                        {!formItem.is_accepted ? (
                                          <span
                                            onClick={() =>
                                              handleFormSelectToggle(
                                                formItem,
                                                "is_accepted"
                                              )
                                            }
                                          >
                                            <Roundcheck />
                                          </span>
                                        ) : (
                                          <span
                                            onClick={() =>
                                              handleFormSelectToggle(
                                                formItem,
                                                "is_accepted"
                                              )
                                            }
                                          >
                                            <RoundcheckGreen />
                                          </span>
                                        )}
                                      </div>
                                    </Space>
                                  </Col>
                                </Row>
                              </div>
                              {formItem.displayValue ? (
                                <></>
                              ) : (
                                <NestedFormViewer
                                  data={Object.fromEntries(
                                    Object.entries(formItem.value).filter(
                                      ([key]) => key !== `is_${formItem?.label}`
                                    )
                                  )}
                                />
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  );
                })}
              </Card>
            ))}
          </div>
        </div>
        <div className="flex-center">
          <Button
            className="common-button-green"
            style={{ alignSelf: "end" }}
            onClick={props.confirmBtnAction}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Drawer>
  );
}

export default AIFormConflictDrawer;
